import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { useAuth } from "@/contexts/AuthProvider";
import { useNavigate } from "react-router-dom"
import { labelSingularLower } from "@/utils/copyTituloBilhete"

export interface DialogNavegarProps {
    exibir: boolean,
    toggleDialog: () => void
}

export function DialogNavegarPosPagamentoInserirCreditos({ exibir, toggleDialog }: DialogNavegarProps) {
    const navigate = useNavigate();
    const { atualizarSaldoDisponivel } = useAuth();

    return (
        <AlertDialog open={exibir}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle className="text-2xl text-primary-foreground">
                        Você já realizou o pagamento?
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        {`Escolha seu ${labelSingularLower()} e finalize sua compra utilizando seu saldo`}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <Button onClick={() => {
                        atualizarSaldoDisponivel();
                        navigate('/compra/titulos')
                    }}>Sim</Button>
                    <Button variant='destructive' onClick={toggleDialog}>Não</Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}